import request from './request'
import { URL_CONTENT_TYPE_JSON } from './consts'

export function vipInfo(data) {
  return request({
    url: '/content/api/cont/init/init_member_config',
    method: 'get',
    params: data
  })
}

export function vipPay(data) {
  return request({
    url: '/content/api/cont/pay/member/get_scan_pay',
    method: 'post',
    data,
    headers: {
      'Content-Type': URL_CONTENT_TYPE_JSON,
    }
  })
}

//首页
export function indexList(data) {
  return request({
    url: '/content/api/cont/init/pc_index',
    method: 'get',
    params: data
  })
}
// banner
export function indexBanner(data) {
  return request({
    url: '/content/api/cont/article/article_banner_list',
    method: 'get',
    params: data
  })
}
//文章
export function articleTabList(data) {
  return request({
    url: '/content/api/cont/init/init_article_config',
    method: 'get',
    params: data
  })
}
export function articleList(data) {
  return request({
    url: '/content/api/cont/article/area_article',
    method: 'get',
    params: data
  })
}
export function articleDetail(data) {
  return request({
    url: '/content/api/cont/article/article_detail',
    method: 'post',
    data,
    headers: {
      'Content-Type': URL_CONTENT_TYPE_JSON
    }
  })
}
export function articleRelation(data) {
  return request({
    url: '/content/api/cont/article/relation_article',
    method: 'post',
    data,
    headers: {
      'Content-Type': URL_CONTENT_TYPE_JSON
    }
  })
}
export function articleNear(data) {
  return request({
    url: '/content/api/cont/article/auth_near_article',
    method: 'post',
    data,
    headers: {
      'Content-Type': URL_CONTENT_TYPE_JSON
    }
  })
}
export function articlePay(data) {
  return request({
    url: '/cmbn/xlj/pay/article_pay/get_scan_pay',
    method: 'post',
    data,
    headers: {
      'Content-Type': URL_CONTENT_TYPE_JSON
    }
  })
}
export function checkArticleScanPay(data) {
  return request({
    url: '/cmbn/xlj/pay/article_pay/check_scan_pay',
    method: 'get',
    params: data
  })
}

//学院
export function filterList(data) {
  return request({
    url: '/content/api/cont/init/init_report_config',
    method: 'get',
    params: data
  })
}
export function curriculumList(data) {
  return request({
    url: '/content/api/cont/college/curriculum_list',
    method: 'get',
    params: data
  })
}

export function curriculumDetail(data) {
  return request({
    url: '/content/api/cont/college/curriculum_detail',
    method: 'post',
    data,
    headers: {
      'Content-Type': URL_CONTENT_TYPE_JSON
    }
  })
}
export function curriculumVideoDetail(data) {
  return request({
    url: '/content/api/cont/college/curriculum_video_detail',
    method: 'post',
    data,
    headers: {
      'Content-Type': URL_CONTENT_TYPE_JSON
    }
  })
}



//搜索
export function hotSearchList(data) {
  return request({
    url: '/content/api/cont/search/hot_search_list',
    method: 'get',
    params: data
  })
}

export function likeSearchList(data) {
  return request({
    url: '/content/api/cont/search/like_search',
    method: 'post',
    data,
    headers: {
      'Content-Type': URL_CONTENT_TYPE_JSON
    }
  })
}

//用户
export function userInfo(data) {
  return request({
    url: '/content/api/cont/userinfo',
    method: 'get',
    params: data
  })
}
export function phoneLogin(data) {
  return request({
    url: '/weixin/api/ma/wxuser/exempt/phone_login',
    method: 'post',
    data,
    headers: {
      'Content-Type': URL_CONTENT_TYPE_JSON
    }
  })
}
export function sendCode(data) {
  return request({
    url: '/weixin/api/ma/wxuser/exempt/sms_send',
    method: 'get',
    params: data
  })
}
export function loginGrCode(data) {
  return request({
    url: '/weixin/api/ma/wxuser/exempt/get_login_qrcode',
    method: 'post',
    data,
    headers: {
      'Content-Type': URL_CONTENT_TYPE_JSON
    }
  })
}
export function checkScanLogin(data) {
  return request({
    url: '/weixin/api/ma/wxuser/exempt/check_login_qrcode',
    method: 'get',
    params: data
  })
}
export function collectList(data) {
  return request({
    url: '/content/api/cont/collect/collect_college_list',
    method: 'get',
    params: data
  })
}
export function saveCollect(data) {
  return request({
    url: '/content/api/cont/collect/save_collect',
    method: 'post',
    data,
    headers: {
      'Content-Type': URL_CONTENT_TYPE_JSON
    }
  })
}
export function cancelCollect(data) {
  return request({
    url: '/content/api/cont/collect/del_collect',
    method: 'post',
    data,
    headers: {
      'Content-Type': URL_CONTENT_TYPE_JSON
    }
  })
}

export function searchArticleList(data) {
  return request({
    url: '/content/api/cont/search/article_list',
    method: 'get',
    params: data
  })
}
export function searchCollegeList(data) {
  return request({
    url: '/content/api/cont/search/college_list',
    method: 'get',
    params: data
  })
}
export function checkScanPay(data) {
  return request({
    url: '/content/api/cont/pay/member/check_scan_pay',
    method: 'get',
    params: data
  })
}
export function collegePay(data) {
  return request({
    url: '/content/api/cont/pay/college/get_scan_pay',
    method: 'post',
    data,
    headers: {
      'Content-Type': URL_CONTENT_TYPE_JSON
    }
  })
}
export function logout(data) {
  return request({
    url: '/weixin/api/ma/wxuser/exempt/login_out',
    method: 'get',
    params: data
  })
}




// WEBPACK FOOTER //
// ./src/network/api.js